import type { FC } from 'react';
import { useState } from 'react';
import { getMarketsAnalyticsEvents } from '@mwl/core-lib';
import CloseIcon from '@public/assets/common/icons/close.svg';
import MoreIcon from '@public/assets/common/icons/more.svg';
import { Button } from '@/components/Button/Button';
import { ButtonIcon } from '@/components/ButtonIcon/ButtonIcon';
import { Tooltip } from '@/components/Tooltip/Tooltip';
import type { MarketsFilterAdditionalProps } from './MarketsFilterAdditional.types';
import styles from './MarketsFilterAdditional.module.scss';
const MarketsFilterAdditional: FC<MarketsFilterAdditionalProps> = ({
  filters,
  offset = [0, 8],
  onFilterClick,
  activeFilter,
  counts,
  totalCount
}) => {
  const [isShow, setIsShow] = useState(false);
  const analyticsData = getMarketsAnalyticsEvents(totalCount, counts[(activeFilter as number)], filters?.find(item => item.id === activeFilter)?.title);
  const onShow = () => {
    setIsShow(true);
  };
  const onHide = () => {
    setIsShow(false);
  };
  if (filters.length === 0) {
    return null;
  }
  const list = <div>
      {filters.map(filter => <Button as="button" fontSize="sm" color="black-light" variant="text" fullWidth align="left" key={filter.id} className={cn(styles.item, {
      [styles.active]: activeFilter === filter.id
    })} onClick={() => onFilterClick(filter.id)}>
          {filter.title}
          <span className={styles.count}>{counts[filter.id]}</span>
        </Button>)}
    </div>;
  return <div className={styles.root} data-sentry-component="MarketsFilterAdditional" data-sentry-source-file="MarketsFilterAdditional.tsx">
      <Tooltip maxWidth="none" onShow={onShow} onHide={onHide} variant="window" placement="bottom" trigger="click" content={list} offset={offset} classes={{
      content: styles.content
      // wrapper: styles.wrapper,
    }} data-sentry-element="Tooltip" data-sentry-source-file="MarketsFilterAdditional.tsx">
        <ButtonIcon className={cn(styles.button, {
        [styles.opened]: isShow,
        [styles.active]: filters.some(filter => filter.id === activeFilter)
      })} as="button" analytics={analyticsData.more} variant="text" size="sm" aria-label="more" data-sentry-element="ButtonIcon" data-sentry-source-file="MarketsFilterAdditional.tsx">
          {isShow ? <CloseIcon width={16} height={16} /> : <MoreIcon width={24} height={24} />}
        </ButtonIcon>
      </Tooltip>
    </div>;
};
export { MarketsFilterAdditional };